<template>
  <div>
    <div class="toolbtn flex">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <el-skeleton
      class="width100"
      :loading="true"
      animated
      :throttle="500"
      v-if="total != 0"
    >
      <template slot="template">
        <div
          class="
            width100
            margin-auto
            backwhite
            margin-top10
            pad-top20 pad-bot10
            alldigital
            border-rd3
          "
        >
          <el-table :data="pages" class="eltable width98 margin-auto f14">
            <el-table-column label="商标名称" align="left">
              <template slot-scope="scope"
                ><span
                  class="bluecolor cursorpointer"
                  @click="todetails(scope.row)"
                >
                  {{
                    scope.row.trademark == null
                      ? ""
                      : scope.row.trademark.TrademarkName
                  }}</span
                >
              </template></el-table-column
            >
            <el-table-column label="国际分类" align="center"
              ><template slot-scope="scope"
                >第{{
                  scope.row.trademark == null
                    ? ""
                    : scope.row.trademark.InternationalClass
                }}类</template
              ></el-table-column
            >
            <el-table-column label="商标号码" align="center"
              ><template slot-scope="scope">{{
                scope.row.trademark == null ? "" : scope.row.trademark.RegNumber
              }}</template></el-table-column
            >
            <el-table-column label="申请日期" align="center"
              ><template slot-scope="scope">{{
                scope.row.trademark == null ? "" : scope.row.trademark.ApplyDate
              }}</template></el-table-column
            >
            <el-table-column label="申请人" align="center"
              ><template slot-scope="scope">{{
                scope.row.trademark == null
                  ? ""
                  : scope.row.trademark.RegisterName
              }}</template></el-table-column
            >
            <el-table-column label="协同目标" align="center"
              ><template slot-scope="scope">{{
                scope.row.trademark == null
                  ? ""
                  : scope.row.trademark.IsWellKnown
              }}</template></el-table-column
            >
            <el-table-column
              label="操作"
              align="center"
              width="320"
              class-name="small-padding fixed-width"
            >
              <template slot-scope="scope">
                <span
                  class="bluecolor cursorpointer"
                  @click="nullshare(scope.row)"
                  >取消分享</span
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="flex-betweennowrap pad-top20 width98 margin-auto">
            <span class="bluecolor"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
              v-if="total != 0"
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </el-skeleton>
    <div
      class="width100 margin-auto backgroudFFF margin-top15"
      v-if="total == 0"
    >
      <el-empty
        :image="require('@/assets/barsvg/zwsj@3x.png')"
        :image-size="200"
        description="抱歉，没有搜到您想要的内容"
        class="heightempty"
        ><p style="position: relative; bottom: 60px" class="f14">
          暂无数据
        </p></el-empty
      >
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  followtrademarkmyshare,
  followtrademarkclose,
} from "@/api/patent/patent.api";
import callback from "@/components/callback.vue";

import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      thisNum: 1,
      pages: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      pagination: false,
      centerDialogVisible: false,
      Remind: 0,
      behalf: 0,
      sell: 0,
      date: "",
      serchkey: true,
      input: "",
      companytitle: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },
  components: {
    callback,
  },

  methods: {
    // 取消分享
    nullshare(row) {
      this.$confirm("此操作将取消分享, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          followtrademarkclose({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                showClose: true,
                message: "取消分享成功",
                type: "success",
              });
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    Submitfrom() {},
    // 跳转详情
    todetails(row) {
      window.sessionStorage.setItem("treadlookout", row.trademark.ItemKey);
      this.$router.push({
        path: "/intellectual-property/trademarklookout-details",
      });
    },
    // 分页
    currentchange(val) {
      this.thisNum = val;
      followtrademarkmyshare({
        page: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.trademark.IsWellKnown == "") {
              i.trademark.IsWellKnown = "否";
            }
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      followtrademarkmyshare({
        page: 1,
        limit: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.trademark.IsWellKnown == "") {
              i.trademark.IsWellKnown = "否";
            }
          });
        } else {
          this.drawer = false;
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      followtrademarkmyshare({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.trademark.IsWellKnown == "") {
              i.trademark.IsWellKnown = "否";
            }
          });
        } else {
          this.drawer = false;
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    window.sessionStorage.setItem("default", "个人中心");
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    this.companytitle = window.sessionStorage.getItem("companytitle");

    this.$loading.show(); // 显示loading
    followtrademarkmyshare({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.$loading.hide(); // 隐藏loading
        this.pages = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
        this.pages.forEach((i) => {
          if (i.trademark.IsWellKnown == "") {
            i.trademark.IsWellKnown = "否";
          }
        });
      } else {
        this.drawer = false;
        this.$loading.hide(); // 隐藏loading
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>